import { UPDATE_DEFECTS } from '../actions/tasks';
import { LOGOUT } from '../actions/screen';
import { UPDATE_DEFECTS_STATUS } from '../actions/defects';

const initialState = {};

export default (state = initialState, action) => {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case UPDATE_DEFECTS:
            action.data.forEach((item) => {
                newState[item.id] = Object.assign({}, item);
            });

            return newState;
        case UPDATE_DEFECTS_STATUS:
            action.data.downloaded.forEach((item) => {
                newState[item] = Object.assign({}, newState[item], { isDownloaded: true });
            });

            return newState;
        case LOGOUT:
            return initialState;
        default:
            return state;
    }
};
